import {
  ActionTypes,
  IGetkpisRequestReturn,
  IGetKpisSuccessReturn,
  IKpisInput,
  IKpisSuccessInput,
} from './types';
import { IKpi } from '../../../types/kpis';

export function getKpisRequest(input: IKpisInput): IGetkpisRequestReturn {
  return {
    type: ActionTypes.getKpisRequest,
    payload: {
      input,
    },
  };
}

export function getKpisSuccess(
  input: IKpisSuccessInput,
): IGetKpisSuccessReturn {
  return {
    type: ActionTypes.getKpisSuccess,
    payload: {
      input,
    },
  };
}

export function getKpisFailure(kpis: IKpi[]): any {
  return {
    type: ActionTypes.getKpisFailure,
    payload: {
      kpis,
    },
  };
}
